import React from 'react';
import { Chip } from '@mui/material';

const MATURITY_COLORS = {
  'Initial': { bg: '#ffebee', text: '#c62828' },
  'Developing': { bg: '#fff3e0', text: '#ef6c00' },
  'Defined': { bg: '#e3f2fd', text: '#1565c0' },
  'Managed': { bg: '#e8f5e9', text: '#2e7d32' },
  'Optimized': { bg: '#f3e5f5', text: '#7b1fa2' },
};

const MATURITY_LABELS_PT = {
  'Initial': 'Inicial',
  'Developing': 'Em Desenvolvimento',
  'Defined': 'Definido',
  'Managed': 'Gerenciado',
  'Optimized': 'Otimizado',
};

/**
 * MaturityBadge - Displays maturity level as a colored chip
 * @param {string} label - Maturity level (Initial, Developing, Defined, Managed, Optimized)
 * @param {string} size - Chip size (small, medium)
 */
export const MaturityBadge = ({ label, size = 'medium' }) => {
  const colors = MATURITY_COLORS[label] || { bg: '#f5f5f5', text: '#757575' };
  const displayLabel = MATURITY_LABELS_PT[label] || label;

  return (
    <Chip
      label={displayLabel}
      size={size}
      sx={{
        bgcolor: colors.bg,
        color: colors.text,
        fontWeight: 500,
        fontSize: size === 'small' ? '0.75rem' : '0.875rem',
      }}
    />
  );
};
